<template>
  <div>
    <!-- MOVE MODAL -->
    <move-question-modal ref="moveQuestionModal"></move-question-modal>


    <b-table :fields="fields" :items="items" @row-clicked="showDetails" reactive>
      <template v-slot:cell(question)="row">
        {{ row.item.question }}
      </template>

      <template v-slot:cell(buttons)="row">
        <span style="white-space: nowrap">
          <b-button variant="danger" size="sm" class="mr-1" v-on:click.stop="$emit('deleteQuestion', row.item.id)">
            <font-awesome-icon icon="trash-alt"></font-awesome-icon>
          </b-button>
          <b-button variant="secondary" size="sm" class="mr-1" v-on:click.stop="moveQuestion(row.item)">
            <font-awesome-icon icon="arrows-alt-v"></font-awesome-icon>
          </b-button>
          <b-button variant="secondary" size="sm" v-on:click.stop="$emit('editQuestion', row.item.id)">
            <font-awesome-icon icon="edit"></font-awesome-icon>
          </b-button>
        </span>
      </template>

      <template v-slot:row-details="row" @clicked="row.toggleDetails">
        <b-row class="mb-2" v-if="row.item.image">
          <b-col sm="1" class="text-sm-right"><b>Bild:</b></b-col>
          <b-col>
            <img :src="'//' + row.item.imagePath + '/' +row.item.id + '/' + row.item.image" style="float:left;max-width: 130px"/>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="1" class="text-sm-right"><b>A:</b></b-col>
          <b-col :class="row.item.correct == 'a' ? 'font-weight-bold' : ''">
              {{ row.item.answers.a }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="1" class="text-sm-right"><b>B:</b></b-col>
          <b-col :class="row.item.correct == 'b' ? 'font-weight-bold' : ''">
            {{ row.item.answers.b }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="1" class="text-sm-right"><b>C:</b></b-col>
          <b-col :class="row.item.correct == 'c' ? 'font-weight-bold' : ''">
            {{ row.item.answers.c }}
          </b-col>
        </b-row>
      </template>
    </b-table>
  </div>
</template>
<script>
import MoveQuestionModal from '@/components/competitions/admin/MoveQuestionModal'

export default {
  name: 'QuestionsTable',
  props: ['questions'],

  components: {
    moveQuestionModal: MoveQuestionModal
  },

  data: function () {
    return {
      fields: [
        {key: 'position', label: '#'},
        {key: 'question', label: 'Frage'},
        {key: 'buttons', label: '', classes: 'w-10'}
      ],
      items: []
    }
  },

  watch: {
    questions: function () {
      this.load()
    }
  },

  methods: {
    showDetails: function (item) {
      this.items.forEach((row) => {
        if (row.id !== item.id) {
          row._showDetails = false
        }
      })

      item._showDetails = !item._showDetails
    },

    moveQuestion: function (question) {
      this.$refs.moveQuestionModal.show(question, this.questions.length)
    },

    load: function () {
      this.$set(this, 'items', [])

      this.questions.forEach((question) => {
        this.items.push({
          id: question.id,
          position: question.position,
          question: question.question,
          image: question.image,
          imagePath: question.imagePath,
          answers: question.answers,
          correct: question.correct.toLowerCase(),
          _showDetails: true
        })
      })
    }
  }
}
</script>
<style scoped>
  b-col.text-sm-right {
    border-right: 1px solid;
  }
  tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/QuestionsTable.vue